import ContactPage from '../elements/ContactPage';

function ContactUs() {
  return <ContactPage initialTab="general" />;
}

export default ContactUs;
